<script setup lang="ts">
import { computed } from 'vue';

import type { IngredientType } from '@libs/trip-planner-interfaces';
import { AppSvgIcon } from '@libs/ui';
import type { AppSvgIconType } from '@libs/ui';

import { getIconsChunks } from './helpers';

interface TripIndicatorProps {
  ingredientTypes: IngredientType[];
  activeIngredientIndex: number;
}

const props = defineProps<TripIndicatorProps>();

const iconsChunks = computed<Array<Array<AppSvgIconType | undefined>>>(() =>
  getIconsChunks(props.ingredientTypes)
);
</script>

<template>
  <div class="trip-indicator">
    <div
      v-for="(iconsChunk, chunkIndex) in iconsChunks"
      :key="chunkIndex"
      class="chunk"
    >
      <template v-for="(icon, index) in iconsChunk" :key="index">
        <div v-if="icon" class="icon">
          <div v-if="index > 0" class="plus">+</div>
          <AppSvgIcon
            :name="icon"
            size="18"
            :color="
              index === props.activeIngredientIndex
                ? 'color-secondary-40'
                : 'color-secondary-85'
            "
          />
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped lang="scss">
.trip-indicator {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);

  .chunk {
    display: flex;
    gap: var(--spacing-4);

    .icon {
      display: flex;
      gap: var(--spacing-4);

      .plus {
        color: var(--color-secondary-85);
      }
    }
  }
}
</style>
